<template>
	<div class="videocall-grid-container w-100 h-100"  style="height: 80vh; width: 80vw;">
		<VideoCallList :localStream="localStream" :remotes="remoteStreams" :usersInRoom="usersInRoomState" />
		<div v-if="localStream" class="videocall-self-container-local">
			<video autoplay :srcObject.prop="localStream" muted class="video-element-local"></video>
			<div class="user-name-video" >Tú</div>
		</div>
		<div v-if="remoteCalledStream" class="videocall-self-container full-container h-100">
			<video ref="remoteCalledStream"
				id="remote"
				autoplay
				:srcObject.prop="remoteCalledStream.stream"
				class="video-elements w-100 mh-100 h-100"></video>
			<CalledUserInfo v-if="userInfo" :userData="userInfo" />
		</div>
		<div style="justify-content: center; align-items:center;height: 100%;" v-else class="full-container h-100 d-flex justify-content-center align-items-center flex-column">
			<div style="justify-content: center; align-items:center;" class="d-flex justify-content-center align-items-center flex-column" v-if="!principalWasInRoom">
    <v-progress-circular
      color="primary"
      indeterminate
    ></v-progress-circular>
				Esperando que el usuario principal se una a la videollamada
			</div>
			<div class="text-center" v-else>
        <font-awesome-icon class="mb-4" icon="video-slash" style="font-size:50px;"/>
				<p class="m-0"><b>El usuario principal se ha desconectado</b></p>
				<p class="mb-2">Puedes intentar reconectar o llamarlo para establecer una conexión más estable</p>
 				<v-row>
   				<v-col cols="6" class="text-center d-flex">
			      <v-btn
			        color="primary"
			        class="bottom-btns-videocall-room d-flex justify-content-center align-items-center py-2"
			        variant="outline"
			        style="flex: 1;font-size: 12px;"
			        @click="reconnectVideoCall(true)"
			      >
			        Intentar conectar
			      </v-btn>
			    </v-col>
   				<v-col cols="6" class="text-center d-flex">
			      <v-btn
			        color="primary"
			        class="bottom-btns-videocall-room d-flex justify-content-center align-items-center py-2"
			        variant="outline"
			        style="flex: 1;font-size: 12px;"
			        @click="reconnectVideoCall(true)"
			      >
			        Llamar al usuario
			      </v-btn>
			    </v-col>
			  </v-row>
			</div>
		</div>
	</div>
</template>

<script>
	import VideoCallList from './VideoCallList'
	import CalledUserInfo from './CalledUserInfo'
/*   	import {initVideoCallWithDevice} from '../../api/atenciones' */

	export default {
	  name: 'VideoCallGrid',
	  components: {VideoCallList, CalledUserInfo},
	  props: {
	  	localStream: {
      	required: true
	  	},
	  	remoteCalledStream: {
      	required: true
	  	},
	  	remoteStreams: {
	  		type: Array,
      	required: true
	  	},
	  	usersInRoom: {
	  		type: Object,
	  		required: true
	  	},
	  	socketRoom: {
	  		type: String,
	  		required: true
	  	}
	  },
		  data(){
			return {
				usersInRoomState: {},
				principalWasInRoom: false,
				userInfo: null,
			}
		  },
		  methods: {
			  async reconnectVideoCall(silent){
				  this.principalWasInRoom = false
				  const videoCallData = this.$store.state.videoCallData
/* 			await initVideoCallWithDevice({
			  to_users: [ videoCallData.calledUserID ],
			  device_id: videoCallData.deviceID,
			  videocall_id: videoCallData.videocallID,
			  socket_room: videoCallData.socketRoom,
			  socket_url: videoCallData.socketUrl,
			  silent
			}) */
			},
	  		switchAudioOut() {
				const remoteVideo = document.getElementById('remote')
				remoteVideo.setSinkId(this.$store.state.audioOutputDevice)
			},
		  },

	  watch: {
	  	usersInRoom(data){
	  		this.usersInRoomState = data
	  		if(this.remoteCalledStream){
	  			this.userInfo = {...this.usersInRoomState[this.remoteCalledStream.socketID]}
	  		}
	  	},
	  	remoteCalledStream(data){
	  		if(data){
	  			this.principalWasInRoom = true
	  			this.userInfo = {...this.usersInRoomState[this.remoteCalledStream.socketID]}
	  		}
	  	},
		  '$store.state.audioOutputDevice': function() {
			this.switchAudioOut()
  		},
	  },
	  mounted(){
	  	this.usersInRoomState = this.usersInRoom
  		if(this.remoteCalledStream){
  			this.principalWasInRoom = true
  			this.userInfo = {...this.usersInRoomState[this.remoteCalledStream.socketID]}

  		}
	  },
	}
</script>

<style lang="scss">
/* .modal-audio {
	background-color: #fff;
	position: absolute;
	top:50%;
	left:50%;
	transform: translate(50%, 50%);
	padding: 20px;
	width: 500px;
	border-radius: 15px;
	border: 1px solid black;
} */
   .title-panel{
    text-align: center;
    padding: 10px 0;
    background: #f2f2f2;
  }
  .modal-monitoreo{width: 90vw;}
  .modal-dialog{max-width: 90vw;}
  .fullmonitor-btn{
    position: absolute;
    top: 0;
    right: 0;
    width: 40px;
    height: 40px;
    z-index: 99999999;
  }
  #monitor.full-monitor .fullmonitor-btn{
    bottom: 20px;
    right: 20px;
  }
  #monitor.full-monitor{
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 999999;
    background-color: rgba(0, 0, 0, 0.7);
  }
  #monitor{
    height: 50vh;
    width: 100%;
    margin: 0;
    position: relative;
    display: flex;
  }
  #monitor-remote{
    display: flex;
    width: 100%;
    position: relative;
    background: #ececec;
  }
  #monitor-remote .blank-video-consulta{
    position: absolute;
    bottom: 0;
    right: 0;
    padding: 10px;
    width: 180px;
    text-align: right;
    background: rgba(255, 255, 255, 0.5);
    z-index: 999999;
    border-radius: 10px;
  }
  #monitor-remote .blank-video-consulta p{
    font-size: 10px;
    margin-bottom: 0;
  }
  #no-remote-video{
    display: flex;
    flex-direction: column;
    align-self: center;
    margin: 100px 50px 0 50px;
    text-align: center;
  }
  #monitor #remote-view{
    height: 50vh;
    width: 100%;
    margin: auto;
    margin-left: 50px;
  }
  #monitor #local-view{
    max-width: 160px;
    position: absolute;
    top: 10px;
    left: 10px;
  }
  #monitor.full-monitor #remote-view{
    width: 100%;
    height: 100%;
  }
  .icon-monitoreo-user{
    color: white;
    background-color: theme-color("primary");
    width: 30px;
    height: 30px;
    text-align: center;
    display: flex; 
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    font-size: 14px;
    margin-right: 15px;
  }
  .name-user-monitoreo{
    display: flex; 
    align-items: center;
    font-weight: bold;
    color: theme-color("primary");
    font-size: 13px;
    border-bottom: 1px solid #E2E2E2;
    padding: 10px 0;
  }
  .active-badge-indicator-monitor{
    width: 10px;
    height: 10px;
    background-color: #42AB0F;
    border-radius: 10px;
    position: absolute;
    bottom: -8px;
    right: 10px;
  }
  .buttons-container-monitoreo{
    display: flex;
    width: 100%;
  }
  .monitores-container-in-modal{
    max-height: 160px;
    overflow-y: scroll;
    margin-bottom: 10px;
  }
  .monitores-container-in-modal.search-user-modal{
    max-height: 350px;
    width: 100%;
  }

  .edit-user-modal .icon-user{
	color: white;
	background-color: theme-color("primary");
	width: 120px;
	height: 120px;
	text-align: center;
	display: flex; 
	align-items: center;
	justify-content: center;
	border-radius: 5px;
	font-size: 38px;
	margin:auto;
}
.calls-dragable{
  border: 2px solid #b3b3b3;
  border-radius: 10px;
  background-color: white;
  width: auto!important;
  height: auto!important;
  padding: 6px 20px;
  max-width: 350px;
}
.img-phone-calls{
  background-color: #39B549;
  width: 40px;
  height: 40px;
  border-radius: 50px;
}
.item-drop-custom{
  padding: 10px;
  width: 250px;
}

.titulo-factor-medicion-remota{
  margin: 0;
  font-weight: bold;
  background: #095fd4;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  padding: 5px 0;
  color: white;
  border: 1px solid #095fd4;
  border-bottom: 1px solid #f2f2f2;
}
.valor-factor-medicion-remota{
  margin-bottom: 10px;
  font-size: 25px;
  font-weight: bold;
  background: #2d64ed;
  color: white;
  height: 100px;
  text-align: center;
  line-height: 100px;
  border: 1px solid #095fd4;
  border-top: none;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
.titulo-factor-medicion-remota.ecg{
  border-bottom: none;
}
.valor-factor-medicion-remota-ecg{
  border: 1px solid #2d63ed;
  border-top: none;
  padding: 5px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
.valor-factor-medicion-remota span.exp-text{
  font-size: 10px;
}

@keyframes pulse {
  from {
    transform: scale3d(1, 1, 1);
  }

  50% {
    transform: scale3d(1.05, 1.05, 1.05);
  }

  to {
    transform: scale3d(1, 1, 1);
  }
}

.animated {
  animation-duration: 1s;
  animation-fill-mode: both;
}
.animated.infinite {
  animation-iteration-count: infinite;
}
.pulse {
  animation-name: pulse;
}

.reportecg-dragable{
  border: 2px solid #b3b3b3;
  border-radius: 10px;
  background-color: white;
  width: auto!important;
  height: auto!important;
  padding: 6px 20px;
  max-width: 550px;
	max-height: 700px;
	position: absolute;
}
.reportecg-img-dragable{
  border: 2px solid #b3b3b3;
  border-radius: 10px;
  background-color: white;
  width: auto!important;
  height: auto!important;
  padding: 6px 20px;
  max-width: 550px;
}
.reportecg-dragable .title-report{
  background: #2d64ed;
  color: white;
  padding: 5px;
}

.ficha-paciente-container .user-data{
  display: flex;
  align-items: center;
  padding: 15px;
}
.ficha-paciente-container .user-data .datos-usuario,
.ficha-paciente-container .user-data .datos-enfermedades{
  flex: 1;
}
.ficha-paciente-container .user-data .icon-user{
  padding: 10px;
  background-color: #0064ed;
  color: white;
  font-size: 40px;
  height: 100px;
  display: flex;
  align-items: center;
  width: 100px;
  justify-content: center;
  border-radius: 100px;
}
.ficha-paciente-container .user-data .datos-usuario{
  font-size: 14px;
  margin-left: 15px;
}
.ficha-paciente-container .ficha-paciente-card{
  border: 1px solid #0064ed;
  border-radius: 10px;
  margin: 15px 0;
}
.ficha-paciente-container .ficha-paciente-card h4{
  padding: 10px;
  background-color: #0064ed;
  color: white;
  text-align: center;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
}
.datepicker-iduam input{width: 100%;}
.holters-programados-title{
  background-color:#0064ed;
  color: white;
}
#monitor-remote-pip,
#monitor-remote-pip #monitor-remote-pip-view{
  height: 400px;
  max-width: 400px;
  margin: auto;
}
#monitor-remote-pip{display: flex; justify-content: 'center'; align-items: 'center'}
#monitor-remote-pip #no-remote-video{
  margin: 0;
  font-size: 10px;
}
.pip-monitoreo{
  border-radius: 10px;
  background-color: white;
  width: 400px!important;
  height: auto!important;
  max-width: 600px;
  -webkit-box-shadow: 0px 0px 7px 0px rgba(0,0,0,0.3);
  -moz-box-shadow: 0px 0px 7px 0px rgba(0,0,0,0.3);
  box-shadow: 0px 0px 7px 0px rgba(0,0,0,0.3);
}
.monitor-remote-pip-container{height: 400px;}
.custom-v-select-iduam .vs__dropdown-menu .vs__dropdown-option--highlight{
  background-color: white;
  color: #333;
  font-weight: bold;
}
#remoteViewContainer{
  padding: 20px;
}
#remoteViewContainer .monitoreo-grid-element,
#remoteViewContainer .monitoreo-grid-element video{
  height: 200px;
}
.col-video-monitoreo-container{
  background: #fdfdfd;
  border: 1px solid #0064ed;
  border-radius: 10px;
  position: relative;
}
.col-video-controls-monitoreo-container{
  background: #0064ed;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}


.top-container{
  padding: 20px;
  border-bottom: 1px solid #CBCBCB;
  position: relative;
  background: white;
/*    -webkit-box-shadow: 25px -150px 138px 70px rgba(87,87,87,1);
  -moz-box-shadow: 25px -150px 138px 70px rgba(87,87,87,1);
  box-shadow: 25px -150px 138px 70px rgba(87,87,87,1);*/
}
.bottom-container{padding: 20px;}
.custom-title-info-window{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 15px;
}
.custom-title-info-window hr{
  margin: 0;
  width: 100%;
  margin-left: 10px;
}
.icons-svg{
  width: 2rem!important;
  height: 2rem!important;
}
.icons-svg.outline{
  fill: transparent;
  stroke: currentColor;
  stroke-width: 2px;
}
.custom-button-info-content{
  border-color: #CBCBCB;
  color: #666666;
  height: 57px;
}
.custom-button-info-content.square-custom{
  width: 57px;
}
.custom-button-info-content.success{
  color: white;
}
.input-notification-info-window-sos{padding: 20px 20px;}
.bottom-container.small-buttons-custom{padding: 5px;background: #f7f7f7;}
.small-buttons-custom .custom-button-info-content{
  font-size: 0.6rem;
  height: 40px;
}
.small-buttons-custom .icons-svg{
  width: 1.2rem!important;
  height: 1.2rem!important;
}

.modal-monitoreo .modal-body{padding:0;background-color: #F7F7F7;}
.modal-monitoreo .modal-content{border: none;}

.modal-monitoreo .custom-button-info-content{
  height: 40px;
}
.modal-monitoreo .border-light{
  border-left: 0!important;
  border-right: 0!important;
}

.scroll-hidden-vertical-sos::-webkit-scrollbar {
  display: none;
}
.scroll-hidden-vertical-sos {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}

@media (min-width: 576px){
  .modal-monitoreo .modal-dialog{margin-top: 4rem;}
}
/* @media (min-width: 992px){
  .c-sidebar.c-sidebar-lg-show.c-sidebar-fixed ul.c-sidebar-nav{
    margin-top: 100px;
  }
} */


.fullscreen-modal{
  margin: 0;
}
.fullscreen-modal .modal-dialog,.fullscreen-modal .modal-dialog .modal-content{
  min-height: 100vh;
  min-width: 100vw;
  max-height: 100vh;
  max-width: 100vw;
  height: 100vh;
  width: 100vw;
  margin: 0;
  border: 0;
  border-radius: 0;
}
.fullscreen-modal .modal-dialog,.fullscreen-modal .modal-dialog .modal-content .modal-body{
  padding: 0;
  min-height: 100vh;
  min-width: 100vw;
  max-height: 100vh;
  max-width: 100vw;
  height: 100vh;
  width: 100vw;
  // flex: 0 1 auto!important;
}
.fullscreen-modal .modal-dialog,.fullscreen-modal .modal-dialog .modal-content .modal-footer{
  // flex: 1!important;
  
}
.fullscreen-modal.no-header .modal-dialog .modal-content .modal-header,
.fullscreen-modal .modal-dialog .modal-content .modal-footer{display:none;}
.bottom-btns-videocall-room{
  border-color: #CBCBCB;
  color: #666666;
  border-radius: 0;
}
.bottom-btns-videocall-room.first-border-radius{
  border-radius: 0;
  border-bottom-left-radius: 8px;
}
.bottom-btns-videocall-room.last-border-radius{
  border-radius: 0;
  border-bottom-right-radius: 8px;
  
}
.videocall-self-container,.videocall-grid-container{
  position: relative;
}
.videocall-self-container.full-container{

}
.videocall-self-container .video-elements{
  max-width: 100vw;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 9;
}
.videocall-self-container .video-elements.cover-video{
  object-fit: cover;
}
.videocall-self-container .user-name-video{
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(255,255,255,0.8);
  padding: 2px 10px;
  z-index: 9999;
  border-bottom-right-radius: 10px;
}
.videocall-self-container{
  z-index: 9;
  background-color: #4e4e4e;
}
.videocall-self-container-local{
  position: absolute;
  height: 150px;
  width: 170px;
  bottom: 10px;
  left: 10px;
  z-index: 9999;
  border-radius: 10px;
  border: 1px solid rgba(255,255,255,0.4);
}
.videocall-self-container-local .video-element-local{
  position: absolute;
  height: 100%;
  width: 100%;
  bottom: 0;
  left: 0;
  border-radius: 10px;
  object-fit: cover;
}
.videocall-self-container-local .user-name-video{
  position: absolute;
  bottom: 0;
  left: 0;
  border-top-right-radius: 10px;
  border-bottom-left-radius: 10px;
  background-color: rgba(255,255,255,0.8);
  padding: 2px 10px;
}
.videocalllist-container{
  position: absolute;
  top: 0;
  right: 10px;
  min-height: 10px;
  width: 20%;
  min-width: 200px;
  background-color: #f2f2f2;
  z-index: 99;
  border-bottom-right-radius: 0.2rem;
  border-bottom-left-radius: 0.2rem;
}
.videocalllist-container.expanded .remotes-container{
  max-height: 70vh;
  overflow: scroll;
}
.videocalllist-container .videocall-self-container{
  height: 100px;
  border: 1px solid #CBCBCB;
}
.videocalllist-container .videocall-self-container .video-elements{
  height: 100px;
}
.videocalllist-container .remotes-container .button-list{
  z-index: 99999;
  position: absolute;
  top: 0;
  right: 0;
}
.calluserinfo-container{
  position: absolute;
  top: 0;
  left: 10px;
  min-height: 10px;
  width: 20%;
  min-width: 220px;
  background-color: #f2f2f2;
  z-index: 99;
  border-bottom-right-radius: 0.2rem;
  border-bottom-left-radius: 0.2rem;
}
.videocall-notes-container{
  position: absolute;
  bottom: 0;
  right: 10px;
  min-height: 10px;
  width: 20%;
  min-width: 220px;
  background-color: #f2f2f2;
  z-index: 99;
  border-top-right-radius: 0.2rem;
  border-top-left-radius: 0.2rem;
}
.videocall-externalcontainer{position: relative;}
.videocall #videos-container .video-container{
  padding: 0;
}
.videocall #user-video-container{
  position: relative;
}
.videocall #btns-container{background: #f2f2f2;border-top: 1px solid #CBCBCB;}
.videocall-pip-container{
  width: 300px;
  height: 400px;
  display: flex;
  flex-direction: column;
}
.videocall-pip-called-video{
  width: 300px;
  height: 250px;
  min-height: 70%;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  background-color: #4e4e4e;
}
.videocall-pip-video-container{
  position: relative;
  height: 250px;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
}
.videocalls-dragable{
  border: 2px solid #b3b3b3;
  border-radius: 10px;
  background-color: white;
  width: auto!important;
  height: auto!important;
  padding: 0;
  max-width: 350px;
}
.videocall-pip-container .user-name-video{
  position: absolute;
  bottom: 0;
  left: 0;
  border-top-right-radius: 10px;
  background-color: rgba(255,255,255,0.8);
  padding: 2px 10px;
  font-size: 12px;
}
.custom-carousel.videocall-pip{flex: 1;}
.custom-carousel.videocall-pip .carousel-inner{height: 100%;}
.custom-carousel.videocall-pip .video-element{
  position: absolute;
  height: 100%;
  width: 100%;
  bottom: 0;
  left: 0;
  object-fit: cover;
}
.recording-button{
  background-color: #d0282e;
  color: white;
  border-radius: 5px;
  padding: 3px 5px;
}

.modal-sm .modal-content {
  width: 500px ;
  margin: 0 auto;
}
.modal-md .modal-content {
  width: 600px ;
  margin: 0 auto;
}
</style>